import React from 'react';
import {Modal} from '../modal/Modal';

export function ConfirmControlModal({title, openModal, handleOpen}) {
  return <Modal isStatic={true} open={openModal} handleOpen={handleOpen} forControl={true}>
    <React.Fragment>
      <div className="modal__title">{title}</div>
      <div><button type="button" className="modal__btn modal__btn--cancel btn" disabled={false} onClick={() => handleOpen(false)}>Закрыть</button></div>
    </React.Fragment>
  </Modal>
};
